import React from 'react';
import { STYLES } from '../consts';
import { ChooseCategory } from './drawer-content/choose-category/ChooseCategory';
import { TransactionDetailsHeader } from './drawer-content/TransactionDetailsHeader';
import { TransactionDetails } from './drawer-content/TransactionDetails';
import { TransactionDetailsNavigation } from './drawer-content/TransactionDetailsNavigation';
// import { ExternalTransactionTypes } from '../enum/extranal-transaction-types';
import { AddNote } from './shared/AddNote';
import { TransactionInitiatorPan } from './drawer-content/TransactionInitiatorPan';
import { TransactionReceiptPhoto } from './drawer-content/TransactionReceiptPhoto';
import { TransactionDetailsCategory } from './drawer-content/TransactionDetailsCategory';
import { useStore } from '../../../store';
import { canBeCategorized } from '../types/lili-transaction';

export enum EContentTypes {
  DETAILS, CHOOSE_CATEGORY
}

interface RenderDrawerContentProps {
  activeContentType: EContentTypes | null;
}

const RenderDetailsCommon = () => {
  const transaction = useStore(state => state.selectedTransaction);
  if (!transaction) return null;
  return (
    <div className='flex flex-col px-[40px] pb-[40px] gap-[20px] h-full fadeIn overflow-y-scroll'>
      <TransactionDetailsNavigation />
      <TransactionDetailsHeader />
      <TransactionDetailsCategory transaction={transaction} />
      <TransactionDetails transaction={transaction} />
      {transaction.allowComment && <AddNote transaction={transaction} />}
      {canBeCategorized(transaction) && <TransactionReceiptPhoto transaction={transaction} />}
      <TransactionInitiatorPan />
    </div>
  );
};

const RenderDrawerContent = ({ activeContentType }: RenderDrawerContentProps) => {
  switch (activeContentType) {
    case EContentTypes.DETAILS:
      return <RenderDetailsCommon />;

    case EContentTypes.CHOOSE_CATEGORY:
      return <ChooseCategory />;

    default:
      return null;
  }
};

export const TransactionDetailsDrawer = () => {
  const activeContentType = useStore(state => state.drawerContentType);

  return (
    <div className={STYLES.DETAILS_DRAWER}>
      <RenderDrawerContent activeContentType={activeContentType} />
    </div>
  );
};
